import JSX from "../helpers/react.js";


function OneFooterBlock({name, lineWidth}: {name: string, lineWidth: string}, content: any){
    return (
        <div className="one-block">
            <p className="p">{name}</p>
            <div className="line" style={{
                '--width': lineWidth
            }} />
            {...content}
        </div>
    )
}
function Link({href, className}: {href: string, className?: string}, content: any){
    return (
        <a className={"text-wrapper"+(className?' '+className:'')} href={href}>{content}</a>
    );
}
function Icon({icon,href, alt, width, height}: {href: string, alt: string, icon: string, width: number, height: number}){
    return (
        <a href={href} target="_blank" className="icon">
            <img src={"/img/icon/footer/"+icon} alt={alt} width={width} height={height} loading="lazy"/>
        </a>
    )
}
function Icons(){
    return (
        <div className="icons">
            <Icon icon="youtube.svg" alt="YouTube" href="//youtube.com/channel/UCP-IYfKnhDCcZV7sZWG1ZwA"   width={42} height={30}/>
            <Icon icon="boosty.svg" alt="Boosty" href="//boosty.to/yummyanime"  width={33} height={34}/>
            {!is_ukraine && <Icon icon="vk.svg" alt="vk" href="//vk.com/yummyanime_official"  width={37} height={27}/>}
            <Icon icon="discord.svg" alt="Discord" href="//discord.gg/EyXbaRyBcQ"  width={37} height={27}/>
            <Icon icon="tiktok.svg" alt="TikTok" href="//tiktok.com/@yummyani.me"  width={32} height={35}/>
            <Icon icon="telegram.svg" alt="Telegram" href="//yummyanimeru.t.me"  width={37} height={29}/>
            <Icon icon="pikabu.svg" alt="Pikabu" href="//pikabu.ru/@YummyAnime"  width={32} height={32} />
            {/*TODO: return back after RKN unban*/}
            {/*<Icon icon="instagram.svg" alt="Instagram" href="//instagram.com/yummyani.me" width={32} height={32} />*/}

        </div>
    );
}
export const Footer = () => {
    const newHost = location.host === "yummyani.me" ? "//new.yummyani.me" : "//new.yummy-anime.ru";
    return (
        <footer className="footer bordered-top">
            <div className="container">
                <OneFooterBlock name="НАШИ РЕСУРСЫ" lineWidth='380px'>
                    <Icons />
                    <div className="logo-bottom">
                        <div className="frame">
                            <img src="/img/yummy-logo.svg" alt="" />
                            <div style={{color: '#D0D0D0'}}>Все видео на сайте предоставлены <br/> только для ознакомления.</div>
                        </div>
                    </div>
                </OneFooterBlock>
                <OneFooterBlock name="ИНФОРМАЦИЯ О САЙТЕ" lineWidth='288px'>
                    <Link href="/pages/about-yummy">О САЙТЕ</Link>
                    <Link href="/pages/rules">ПРАВИЛА САЙТА</Link>
                    <Link href="/pages/privacy">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</Link>
                    <Link href="/pages/for-rulers">ИНФОРМАЦИЯ ДЛЯ ПРАВООБЛАДАТЕЛЕЙ</Link>
                    <Link href="/api">API САЙТА</Link>
                </OneFooterBlock>
                <OneFooterBlock name="ТЕХНИЧЕСКАЯ ПОДДЕРЖКА И ПОМОЩЬ" lineWidth='100%'>
                    <Link href="/users/messages#messages2">ЧАТ С ПОДДЕРЖКОЙ</Link>
                    <Link href="//t.me/yummyanidev" className="space">КАНАЛ РАЗРАБОТКИ В ТЕЛЕГРАМ</Link>
                    <div className="text-wrapper space">&nbsp;</div>
                    <div className="text-wrapper">Почта для сотрудничества: <a href="mailto:promotion@yummyani.me" target="_blank">promotion@yummyani.me</a></div>
                    <div className="text-wrapper">Телеграм поддержки для пользователей: <a href="//YummyAnime_support.t.me/" target="_blank">@YummyAnime_support</a></div>
                </OneFooterBlock>
            </div>

            <a
                className="overlap-group"
                href={newHost + location.pathname + location.search}
            >
                <span className={"new-site"}>Новый дизайн сайта</span>
            </a>
            <div className="overlap-group">
                <div className="copyright">
                    <b>© {'2022-'+(new Date).getFullYear()} YummyAnime.</b>
                    <span> Все права защищены.</span>
                </div>
            </div>
        </footer>
    );
};

$(()=>{
    if(!location.pathname.startsWith('/users/messages'))
        document.querySelector('footer')!.replaceWith(<Footer />)
})